<template>
  <div class="container error-component">
    <div class="error-container">
      <div class="error-image">
        <component :is='imageComponent'></component>
      </div>
      <div class="error-info">
        <h1 class="error-title">{{ $t(title) }}</h1>
        <div class="error-subtitle" v-html-safe="$t(legend)"></div>
        <div class="error-subtitle" v-if="codeError" v-html-safe="$t(codeError)"></div>
        <div class="error-btns mt-4">
          <button v-if="buttonGoHome"
                  class="btn btn-primary"
                  @click="goHome"
          >
            {{ $t('button_back_home') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    legend: {
      required: true
    },
    codeError: {
      required: false
    },
    buttonGoHome: {
      required: false,
      default: false
    },
    imageComponentName:  {
      required: false,
      default: 'ErrorDefault'
    }
  },
  name: 'ErrorPage',
  methods: {
    goHome: function () {
      window.location.href = this.$store.getters.getLogoUrlRedirect || `${window.location.protocol}//${window.location.hostname}/booking`
    }
  },
  computed: {
    imageComponent: function () {
      return () => import(`./ErrorPages/${this.imageComponentName}.vue`)
    }
  }
}
</script>

<style lang="sass">
\:root
  --color-image: var(--color-primary)
  --color-image-background: var(--color-background)
.error-component
  height: 100%
  display: flex
  align-self: center
.error-container
  min-height: 100%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  align-self: center
  width: 100%
.error-title
  font-size: var(--font-size-xl)
  line-height: 1
.error-subtitle
  font-size: var(--font-size-lg)
  line-height: 1.25
  margin-bottom: .5rem
.error-image
  display: flex
  justify-content: center
  height: 270px
  width: 100%
  svg
    width: 100%
    margin-bottom: 2rem
.error-btns
  display: flex
  justify-content: center
.image-color-0
  fill: none
  stroke: var(--color-image)
  stroke-miterlimit: 10
.image-color-1
  fill: var(--color-image)
.image-color-2, .image-color-3
  fill: var(--color-image-background)
  stroke: var(--color-image)
.image-color-3
  fill-rule: evenodd
  clip-rule: evenodd
  stroke-miterlimit: 10
@media (min-width: 992px)
  .error-container
    flex-direction: row
  .error-title
    font-size: var(--font-size-d1)
  .error-btns
    justify-content: flex-start
  .error-info
    max-width: 50%
  .error-image
    max-width: calc(50% - 2rem)
    margin-right: 2rem
    width: 100%
    justify-content: flex-start
    height: 100%
    max-height: calc(100vh - 13.5rem)
    svg
      margin-bottom: 0
</style>
